// REFERENCE:
// https://internetcomputer.org/docs/current/references/cli-reference/dfx-ledger/#options

import { ChainId } from "./icrc1/enum/enums"

// ICP
export const E8S = 10 ** 8
export const WALLET_FEE = 0.0001
export const WALLET_FEE_E8S = WALLET_FEE * E8S
export const NETWORK = "Internet Computer"
export const ICP_CANISTER_ID = "ryjl3-tyaaa-aaaaa-aaaba-cai"
export const ICP_EXPLORER = "https://dashboard.internetcomputer.org"
export const BTC_EXPLORER = "https://mempool.space/tx"
export const BTC_NATIVE_ID = "btc-native"
export const ETH_NATIVE_ID = "eth-native"
export const POLYGON_NATIVE_ID = "polygon-native"
export const ARBITRUM_NATIVE_ID = "arbitrum-native"
export const BASE_NATIVE_ID = "base-native"
export const BNB_NATIVE_ID = "bnb-native"
export const CKBTC_CANISTER_ID = "mxzaz-hqaaa-aaaar-qaada-cai"
export const ETHERSCAN_API_KEY = "861Q6D7WDJD35UMUU3NQ6R798IFQ211TU5"
export const INFURA_API_KEY = "010993c30ae14b2b94ff239547b6ebbe"
// Eth MAINNET
// export const CHAIN_ID = BigInt(ChainId.ETH)
// export const CKETH_LEDGER_CANISTER_ID = "ss2fx-dyaaa-aaaar-qacoq-cai"
// export const ETH_EXPLORER = "https://etherscan.io/tx"
// export const MINTER_ADDRESS = "0x18901044688D3756C35Ed2b36D93e6a5B8e00E68"
// export const CKETH_MINTER_CANISTER_ID = "sv3dd-oaaaa-aaaar-qacoa-cai"
// export const CKETH_NETWORK_FEE = BigInt(2000000000000)
// Eth TESTNET
export const CHAIN_ID = BigInt(11155111)
export const CKETH_LEDGER_CANISTER_ID = "apia6-jaaaa-aaaar-qabma-cai"
export const ETH_EXPLORER = "https://sepolia.etherscan.io/tx"
export const MINTER_ADDRESS = "0x2D39863d30716aaf2B7fFFd85Dd03Dda2BFC2E38"
export const CKETH_MINTER_CANISTER_ID = "jzenf-aiaaa-aaaar-qaa7q-cai"
export const CKETH_NETWORK_FEE = BigInt(10000000000)

export const ICP_ROOT_CANISTER_ID = "r7inp-6aaaa-aaaaa-aaabq-cai"
export const ICP_GOV_CANISTER_ID = "rrkah-fqaaa-aaaaa-aaaaq-cai"
export const ICP_INDEX_ID = "qhbym-qaaaa-aaaaa-aaafq-cai"
export const NFIDW_CANISTER_ID = "mih44-vaaaa-aaaaq-aaekq-cai"
export const ICP_DECIMALS = 8
export const BTC_DECIMALS = 8
export const ETH_DECIMALS = 18
export const USDC_DECIMALS = 6
export const MAX_DECIMAL_USD_LENGTH = 2
export const TRIM_ZEROS = /\.?0+$/
